import { toast } from 'react-toastify'
import { withRouter } from 'react-router-dom'
import BaseFiltroAvancadoItemAvaliacao from '../../base/BaseFiltroAvancadoItemAvaliacao'

class FiltroAvancadoItens extends BaseFiltroAvancadoItemAvaliacao {
  handleCheckboxChange = ( event, id, publico, isPublic ) => {
    const { match, onResultClick } = this.props
    const data = {
      avaliacao: match.params.id,
      item: id,
    }
    if ( isPublic && publico === false ) {
      toast.error( 'Este item é privado' )
      return false
    } else {
      onResultClick( event, data )
      return true
    }
  }
}

export default withRouter( FiltroAvancadoItens )
